.previewArea {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* Pointer events are turned off at the previewAndToolbars but we need */
  /* the preview to capture them */
  pointer-events: all;
}

.previewBadge {
  position: absolute;
  z-index: 1;
  bottom: 10px;
  margin-left: 40px;
  background-color: var(--theme-inverted-background);
  border-radius: var(--Common--border-radius);
  padding: var(--spacer-2) var(--spacer-3);
  color: var(--theme-inverted-primary-text);
  display: flex;
  gap: var(--spacer-4);
}

.historyTimeline {
  margin: 0;
  padding: 0;
  list-style: none;
}

.historyTimeline .historyTimelineEntry {
  position: relative;
  padding: 0;
  margin: 0;
  padding-top: 8px;
  padding-left: 40px;
  padding-bottom: 8px;
}

.historyTimelineEntry:hover.fetching {
  cursor: wait;
}

.historyTimeline .historyTimelineEntry:before {
  content: '';
  position: absolute;
  left: 15px;
  width: 1px;
  height: 100%;
  background-color: var(--theme-primary-border);
}

.historyTimeline .historyTimelineEntry:last-of-type:before {
  height: 75%;
}

/* Ensures the first circle is right at the top of the line */
.historyTimeline .historyTimelineEntry:first-of-type:before {
  top: 13px;
}

.historyTimeline .historyTimelineEntry:after {
  content: ' ';
  position: absolute;
  left: 12px;
  top: 13px;
  width: 5px;
  height: 5px;
  background-color: var(--theme-primary-background);
  border: 1px solid var(--theme-primary-text);
  border-radius: 100%;
}

.historyTimelineEntry:hover {
  background-color: var(--theme-list-item-hover-background);
  border-radius: var(--Common--border-radius);
  cursor: pointer;
}

.historyTimelineEntry:not(.historyTimelineEntryActive):hover:has(
    aha-button:hover
  ) {
  background-color: initial;
}

.historyTimelineEntryActive,
.historyTimelineEntryActive:hover:has(aha-button:hover) {
  background-color: var(--theme-list-item-active-background);
}

.historyTimeline .historyTimelineTime {
  color: var(--theme-accent-text);
}

.smallRestoreButton {
  margin-right: var(--spacer-3);
  float: right;
  display: none;
}

.historyTimelineEntry:hover .smallRestoreButton {
  display: block;
}

@keyframes flashBackground {
  0% {
    background-color: rgba(0, 0, 0, 0);
  }

  15% {
    background-color: var(--theme-list-item-active-background);
  }

  100% {
    background-color: rgba(0, 0, 0, 0);
  }
}

.flashBackground {
  animation: flashBackground 2.5s;
}
